export default {
  recipesNotAllowed: 'Der Ofen ist nicht für das Ausführen von Rezepten konfiguriert',
  recipesNotCreated: 'Keine Rezepte verfügbar',
};
